<template>
	<div id="page">
		<div class="page-content">
			<div class="fixed-top-box">
				<div class="page-title page-title-small">
					<h2>
						<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
						یادآورها و وظایف دوره ای
						<!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
					</h2>
					<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
					<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
				</div>
				<div class="card header-card shape-rounded" data-card-height="100">
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
				</div>
				<div v-if="true">
					<div class="card card-style mb-2">
						<div class="p-3 d-flex">
							<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
								<i class="fa fa-filter text-white"></i>
							</button>
							<div class="filter-row-scrollable">
								<div @click="lstFilter('All',null)" id="All" class="filterSelectItem filter-scrollable-box selected">همه </div>
								<div @click="lstFilter('Sended',1)" id="Sended" class="filterSelectItem filter-scrollable-box ">ارسال شده</div>
								<div @click="lstFilter('NotSend',0)" id="NotSend" class="filterSelectItem filter-scrollable-box ">ارسال نشده</div>
							</div>
						</div>
					</div>
				</div>
			</div>


			<span data-menu="menu-language" class="optionMenu"></span>


			<div v-if="true" class="main-content-box">
				<div class="card card-style mb-2" v-for="task in ReminderList" :key="task.reminderId" @click.prevent="openDetails(task.reminderId)">
					<div class="list-group list-custom-small list-icon-0">
						<div class="list-group-div py-2 px-3">
							<div>
								<b class="font-13 text-dark">{{task.title}}</b>
							</div>
							<div>
								<span class="text-muted d-inline-block text-left ltr">{{task.createDateTime}}</span>
							</div>
							<div class="d-flex justify-content-between">
								<div>
									<i v-if="task.taskId==null" class="fa fa-bell color-yellow1-dark ml-0"></i>
									<i v-else class="fa fa-tasks color-green2-dark ml-0"></i>
									<span v-if="task.taskId==null" class="text-muted text-left ltr">یادآور</span>
									<span v-else class="text-muted text-left ltr">وظیفه دوره ای</span>
								</div>
								<span @click.stop="showMenu(task.reminderId)" width="60px"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
							</div>
						</div>
					</div>
				</div>
				<!--<div class="card card-style" v-if="Loading">
					<div class="content">
						<div class="d-flex justify-content-center w-100 py-5">
							<div class="spinner-border color-magenta2-dark" role="status"></div>
						</div>
					</div>
				</div>-->

				<div class="card card-style" v-if="Loading==false && NoMoreData==false && ReminderList.length>0 && ReminderList.length%10==0">
					<div class="content">
						<div class="d-flex justify-content-center w-100">
							<button class="btn btn-outline-info rounded-m" @click="getNextPageForTaskNoteList">نمایش بیشتر</button>
						</div>
					</div>
				</div>
				<div class="card card-style" v-if="ReminderList.length==0 && Loading==false">
					<div class="content">
						<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
						<p class="text-center py-3">یادآوری یافت نشد.</p>
					</div>
				</div>
			</div>

			<div class="card card-style" v-else>
				<div class="content">
					<h4 class="mb-0 text-center">تصاویر بخش یادآورها</h4>
				</div>
				<div class="divider mb-0"></div>
				<div class="gallery-view-controls d-flex justify-content-center">
					<a href="#" class="gallery-view-1-activate"><i class="fa fa-th"></i></a>
					<a href="#" class="gallery-view-2-activate color-highlight"><i class="fa fa-th-large"></i></a>
					<div class="clearfix"></div>
				</div>
				<div class="content my-n1">
					<div class="gallery-views gallery-view-2">
						<a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-1-L.jpg" title="لیست یادآورها و وظایف دوره ای" class="default-link">
							<img src="/assets/images/gallery/reminder-1-500x500.jpg" data-src="/assets/images/gallery/reminder-1-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">لیست یادآورها و وظایف دوره ای</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
						<a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-2-L.jpg" title="ثبت یادآور" class="default-link">
							<img src="/assets/images/gallery/reminder-2-500x500.jpg" data-src="/assets/images/gallery/reminder-2-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">ثبت یادآور</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
						<a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-3-L.jpg" title="انتخاب نوع تکرار یادآور" class="default-link">
							<img src="/assets/images/gallery/reminder-3-500x500.jpg" data-src="/assets/images/gallery/reminder-3-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">انتخاب نوع تکرار یادآور</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
						<a data-lightbox="gallery-1" href="/assets/images/gallery/reminder-4-L.jpg" title="مشاهده جزئیات تاریخ ارسال یادآور" class="default-link">
							<img src="/assets/images/gallery/reminder-4-500x500.jpg" data-src="/assets/images/gallery/reminder-4-500x500.jpg" class="rounded-m preload-img shadow-l img-fluid" alt="img">
							<div class="caption">
								<h4 class="color-theme">مشاهده جزئیات تاریخ ارسال یادآور</h4>
								<div class="divider bottom-0"></div>
							</div>
						</a>
					</div>
				</div>

				<a href="/order" class="btn btn-l btn-icon bg-green2-dark rounded-s shadow-s btn-full btn-margins font-900 text-uppercase text-left mt-3"><i class="fa fa-credit-card text-center"></i>خرید اشتراک اپلیکیشن</a>
			</div>

		</div>

		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn" v-if="isFreeRegist!==true">
				<router-link to="/CreateReminder">
					<div class="icon icon-m rounded-m color-white bg-green2-light">
						<i class="fa fa-plus"></i>
					</div>
				</router-link>
			</div>
		</transition>

		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'EditReminder', params: { reminderId: selectedReminderId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
					<button @click="deleteReminder" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>
				</div>
				<div class="clear"></div>
			</div>
		</div>
		<div id="searchModal" class="modal fade" role="dialog">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header align-items-center">
						<h4 class="modal-title mt-0">جستجو</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body m-0">
						<div class="w-100 search-box rounded-m position-relative mb-3">
							<i class="fa fa-search pr-3"></i>
							<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
						</div>
						<myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>
						<projects class="mb-3" @selectProject="selectProject"></projects>
						<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>
						<button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
							<i class="fa fa-search ml-2"></i>
							جستجو
						</button>
					</div>
				</div>
			</div>
		</div>
		<Help-Menu title="راهنمای ثبت یادآور" keyEn="TaskList"></Help-Menu>

		
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
	</div>



</template>

<script>
	import VueSimpleAlert from "vue3-simple-alert";
	import HelpMenu from '../Components/HelpMenu.vue';
	import calendarFilter from '../Components/CalendarFilter.vue';
	import ProjectList from '../Components/ProjectList.vue';
	import MyTeamList from '../Components/MyTeamList.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu,
			"calendar-filter": calendarFilter,
			"projects": ProjectList,
			"myTeamList": MyTeamList
		},
		data() {
			return {
				page: 1,
				filterId: 0,
				searchKey: "",
				selectedReminderId: 0,
				userId: null,
				projectId: null,
				status: null,
				date: null,
				pageLoaded: false
			};
		},
		computed: {
			ReminderList() {
				return this.$store.getters.GetReminderList;
			},
			Loading() {
				return this.$store.getters.GetLoading;
			},
			NoMoreData() {
				return this.$store.getters.GetReminderNoMoreData;
			},
			isFreeRegist() {
				return this.$store.getters.GetIsFreeRegist;
			},
			UpdateReminderList() {
				return this.$store.getters.GetUpdateReminderList;
			},
		},

		created() {
			this.filterList();
		},
		methods: {
			lstFilter(filterSelect, filterId) {
				this.status = filterId;
				var elements = document.getElementsByClassName('filterSelectItem');
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('selected');
				}
				document.getElementById(filterSelect).classList.add('selected');
				this.filterList();
			},
			showAddButton() {
				this.pageLoaded = true;

			},
			selectDate(d) {
				this.date = d;
			},
			selectProject(d) {
				this.projectId = d;
			},
			selectUser(d) {
				this.userId = d;
			},
			showMenu(reminderId) {
				this.selectedReminderId = reminderId;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			filterList() {
				this.page = 1;
				this.$store.dispatch("GetReminderListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					userId: this.userId,
					projectId: this.projectId,
					status: this.status,
					date: this.date,
					searchKey: this.searchKey
				});
			},
			openDetails(reminderId) {
				this.$router.push({ name: 'EditReminder', params: { reminderId: reminderId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
			deleteReminder() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$http.get("Reminder/Delete?id=" + this.selectedReminderId)
						.then(data => {
							var res = data.data.toString();
							if (res === "1") {
								this.showSuccessMessage("با موفقیت حذف شد.");
								this.filterList();

							}
							else {
								this.showErrorMessage(res);
							}


						});
				});
			},
			pauseVid(id) {
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},

		},
		mounted() {
			this.showAddButton();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		},
		activated() {
			this.showAddButton();
			if (this.UpdateReminderList == true) {
				this.page = 1;
				this.filterList();
			}
			// this.getNextPageForReminderList();
		},
	};
</script>
